import TaskIcon from "./TaskIcon";

const ICONS = [
  "📘", "✏️", "🧮", "📚", "📝",
  "🔬", "🌍", "🎨", "🎵", "🧪",
  "💡", "🔢", "📐", "📊", "🔭",
  "🎲", "💻",
];

export default function TaskIconPicker({ selectedIcon, onSelect }) {
  return (
    <div className="ct-icon-picker">
      {ICONS.map((icon) => (
        <button
          key={icon}
          type="button"
          onClick={() => onSelect(icon)}
          className={`ct-icon-choice ${selectedIcon === icon ? "is-selected" : ""}`}
          aria-label={`Icoon ${icon}`}
        >
          <TaskIcon value={icon} className="ct-picker-icon" />
        </button>
      ))}
    </div>
  );
}
